import React from "react"
import SectionHeader from "./SectionHeader"

const mainSectionHeader = {
  title: "XDI Client Portal",
  body: [
    "Welcome to the XDI Client Portal - your one stop shop for fun, fun, fun.",
    "From here, you can access all of your data in the XDI ecosystem, upload new data, analyse assets, run aggregated analyses, and view reports.",
  ]
}

const MainSectionHeader = () => (
  <SectionHeader title={mainSectionHeader.title} body={mainSectionHeader.body} />
)

export default MainSectionHeader
